export interface FilterValues {
  activity: string | null;
  program: string | null;
  createdBy: string | null;
  dueDate: Date | null;
  status: OpsStreamType | null;
}

export interface FilterOptions {
  activities: string[];
  programs: string[];
  creators: string[];
}
export interface FilterEntry {
  id: number;
  labelContent: string;
  isSelected: boolean;
}
export enum FilterField {
  Activity = 'activity',
  Program = 'program',
  CreatedBy = 'createdBy',
  DueDate = 'dueDate',
}

export enum OpsStreamType {
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
}

